module.exports = __webpack_public_path__ + "static/media/bold.78c0ea19.svg";